import { render } from "./UsersListItem.vue?vue&type=template&id=29564395"
import script from "./UsersListItem.vue?vue&type=script&lang=js"
export * from "./UsersListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__